import React from 'react';
import {
    MDBDropdown,
    MDBDropdownMenu,
    MDBDropdownToggle,
    MDBDropdownItem,
    MDBIcon
} from 'mdb-react-ui-kit';

const CustomizableColumnDropdown = ({ columns, visibleColumns, onToggleColumn }) => {
    return (
        <MDBDropdown className="mb-2">
            <MDBDropdownToggle>
                <MDBIcon fas icon="columns" />
            </MDBDropdownToggle>
            <MDBDropdownMenu style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {columns.map(col => (
                    <MDBDropdownItem
                        key={col.field}
                        link
                        onClick={(e) => {
                            e.preventDefault();  // Prevent default action
                            e.stopPropagation(); // Stop event bubbling
                            onToggleColumn(col.field);
                        }}
                    >
                        <div 
                            className="form-check"
                            onClick={(e) => e.stopPropagation()} // Stop event bubbling
                        >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={visibleColumns[col.field]}
                                onChange={(e) => {
                                    e.stopPropagation(); // Stop event bubbling
                                    onToggleColumn(col.field);
                                }}
                            />
                            <label className="form-check-label">
                                {col.label || col.header}
                            </label>
                        </div>
                    </MDBDropdownItem>
                ))}
            </MDBDropdownMenu>
        </MDBDropdown>
    );
};

export default CustomizableColumnDropdown;